<template>
    <div>
        <div class="mt-3 mb-3" v-if="!hide">
            <b-button variant="light" :to="{name: 'help'}"><i class="fas fa-question-square mr-2"></i> Need some help? View FAQs and Videos</b-button>
        </div>

        <div class="copyright" :class="variant">
            &copy; {{year}} RegisterMyConference.com, a my247ed.com service
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    export default {
        name: "Copyright",
        props: ['variant', 'hide'],
        data: function() {
            return {
                year: moment().format('YYYY')
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '~@/assets/scss/_variables.scss';

    .copyright {
        display: inline-block;
        margin: 0 auto;
        color: rgba(255, 255, 255, 0.7);
        font-size: 0.9rem;
        border-radius: 0.3rem;
        padding: 0.2rem 1rem;

        &.dark {
            background: none !important;
            color: #999;
        }
    }
</style>
